import React from 'react';

import styles from '../title.module.scss';
import { ReactComponent as Lawyer } from '../../../../icons/entities/lawyer.svg';

export const LawyerIcon = <Lawyer className={styles.icon} />;
